const hardCodedList = [
  {
    name: "Stingers Treatment",
    sessionTypeId: 13,
    price: "DROP-IN $12* | MEMBER $10*",
    note: "*PER UNIT",
    link: "/pages/stingers",
  },
  {
    name: "Stingers Consultation",
    sessionTypeId: 24,
    price: "",
    link: "/pages/stingers",
  },
  {
    name: "Fig Shot",
    sessionTypeId: 4073,
    price: "DROP-IN $35 | MEMBER $30",
    link: "/pages/fig-shot",
  },
  {
    name: "Rejuvenate + Plump Treatment (Dermal Fillers)",
    sessionTypeId: 4092,
    price: "DROP-IN FROM $450 | MEMBER FROM $405",
    link: "/pages/fillers",
  },
  {
    name: "Rejuvenate + Plump Consultation (Dermal Fillers)",
    sessionTypeId: 4093,
    price: "",
    link: "/pages/fillers",
  },
  {
    name: "Radiance + Renewal Laser Facial",
    sessionTypeId: 4074,
    price: "DROP-IN $325 | MEMBER $295",
    link: "/pages/radiance-renewal",
  },
  {
    name: "Light Therapy Boost Self-Serve Facial",
    sessionTypeId: 2051,
    price: "DROP-IN $30 | MEMBER $25",
    link: "/pages/light-therapy-boost",
  },
  {
    name: "Pregnancy Core Facial",
    sessionTypeId: 2046,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/pregnancy-facial",
  },
  {
    name: "Collagen + Texture Supers Facial",
    sessionTypeId: 2042,
    price: "DROP-IN $205 | MEMBER $185",
    link: "/pages/collagen-texture",
  },
  {
    name: "All-In Supers Facial",
    sessionTypeId: 2041,
    price: "DROP-IN $185 | MEMBER $165",
    link: "/pages/all-in",
  },
  {
    name: "Hydrate + Glow Core Facial",
    sessionTypeId: 14,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/hydrate-glow",
  },
  {
    name: "LED + Lymphatic Core Facial",
    sessionTypeId: 12,
    price: "DROP-IN $79 | MEMBER $75",
    link: "/pages/led-lymphatic",
  },
  {
    name: "Lift + Tone Core Facial",
    sessionTypeId: 10,
    price: "DROP-IN $125 | MEMBER $115",
    link: "/pages/lift-tone",
  },
  // TORONTO
  {
    name: "Stingers Follow Up",
    sessionTypeId: 27,
    price: "DROP-IN $12 | MEMBER $10",
    link: "/pages/stingers",
  },
  {
    name: "Stingers Treatment",
    sessionTypeId: 17,
    price: "DROP-IN $12* | MEMBER $10*",
    note: "*PER UNIT",
    link: "/pages/stingers",
  },
  {
    name: "Stingers Consultation",
    sessionTypeId: 18,
    price: "",
    link: "/pages/stingers",
  },
  {
    name: "Fig Shot",
    sessionTypeId: 20,
    price: "DROP-IN $35 | MEMBER $30",
    link: "/pages/fig-shot",
  },
  {
    name: "Rejuvenate + Plump Treatment (Dermal Fillers)",
    sessionTypeId: 30,
    price: "DROP-IN FROM $450 | MEMBER FROM $405",
    link: "/pages/fillers",
  },
  {
    name: "Rejuvenate + Plump Consultation (Dermal Fillers)",
    sessionTypeId: 31,
    price: "",
    link: "/pages/fillers",
  },
  {
    name: "Radiance + Renewal Laser Facial",
    sessionTypeId: 15,
    price: "DROP-IN $325 | MEMBER $295",
    link: "/pages/radiance-renewal",
  },
  {
    name: "Light Therapy Boost Self-Serve Facial",
    sessionTypeId: 22,
    price: "DROP-IN $30 | MEMBER $25",
    link: "/pages/light-therapy-boost",
  },
  {
    name: "Pregnancy Core Facial",
    sessionTypeId: 14,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/pregnancy-facial",
  },
  {
    name: "Collagen + Texture Supers Facial",
    sessionTypeId: 13,
    price: "DROP-IN $205 | MEMBER $185",
    link: "/pages/collagen-texture",
  },
  {
    name: "All-In Supers Facial",
    sessionTypeId: 12,
    price: "DROP-IN $185 | MEMBER $165",
    link: "/pages/all-in",
  },
  {
    name: "Hydrate + Glow Core Facial",
    sessionTypeId: 9,
    price: "DROP-IN $99 | MEMBER $95",
    link: "/pages/hydrate-glow",
  },
  {
    name: "LED + Lymphatic Core Facial",
    sessionTypeId: 8,
    price: "DROP-IN $79 | MEMBER $75",
    link: "/pages/led-lymphatic",
  },
  {
    name: "Lift + Tone Core Facial",
    sessionTypeId: 7,
    price: "DROP-IN $125 | MEMBER $115",
    link: "/pages/lift-tone",
  },
];

const contentElement = document.getElementById("content");
const overlayElement = document.getElementById("overlay");

function scrollToTopAndHighlight() { 
  // scroll to top of page
  window.scrollTo({ top: 0, behavior: "smooth" });

  // add highlight class to content element
  contentElement.classList.add("highlight");

  // show overlay
  overlayElement.style.display = "block";

  // add click event listener to overlay to hide it and remove highlight class
  overlayElement.addEventListener("click", function () {
    overlayElement.style.display = "none";
    contentElement.classList.remove("highlight");
  });
}

const where = document.getElementById("options_site_id");
const bar = document.getElementById("locationSelect");
const treatment = document.getElementById("options_treatment_id");

const bookApptBtn = document.getElementById("book-appt-btn");
const dateSelect = document.getElementById("options_date_id");
const datePickerStart = document.getElementById("datePickerStart");
const datePickerEnd = document.getElementById("datePickerEnd");
const barCollection493689 =
  document.getElementsByClassName("bar-option-493689");
const barCollection5726529 =
  document.getElementsByClassName("bar-option-5726529");
const treatCollection493689 = document.getElementsByClassName(
  "treat-option-493689"
);
const treatCollection5726529 = document.getElementsByClassName(
  "treat-option-5726529"
);
const bookBtn = document.getElementById("book-btn");
const bookingContents = document.getElementById("booking-contents");
const bookHolder = document.getElementById("book_holder");

const bookingNotAvailable = document.getElementById("booking-not-available");
let wehoBars = [];
let torontoBars = [];
let vancouverBars = [];
let torontoTreatments25 = [];
let vancouverTreatments25 = [];
let wehoTreatments25 = [];
bookBtn.disabled = true;
bookBtn.onclick = () => quickbarBookAppointment();

// Function to parse URL parameters
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

  document.addEventListener("DOMContentLoaded", () => {
  const region = (localStorage.getItem('userRegion') || '').toUpperCase();
  const select = document.getElementById("options_site_id");

  if (!select || !region) return; // no region = do nothing

  [...select.options].forEach(option => {
    const text = option.textContent.trim().toUpperCase();

    if (region === "US") {
      if (text === "VANCOUVER" || text === "TORONTO") {
        // option.remove();
        getLocationsBySite("5729211");
      }
    } else if (region === "SA") {
      if (text === "LOS ANGELES") {
        // option.remove();
        getLocationsBySite("493689");
      }
    }
  });
});

// Check if the 'site' parameter exists
window.onload = function () {
  var siteParam = getParameterByName("site");
  if (siteParam !== null) {    
    getLocationsBySite(siteParam);
    // You can perform further actions based on the presence of the parameter
  } else {
    getLocationsBySite("493689");
  }
};

function resetBooking(level) {
  const treatmentHolder = document.getElementById("treatment-holder");
  const barHolder = document.getElementById("bar-holder");

  // console.log("🚀 ~ file: booking.js:28 ~ resetBooking ~ level", level);
  if (["where"].includes(level)) {
    bookBtn.disabled = true;
    bookingContents.style.display = "none";
    bookHolder.style.display = "none";
    bookingNotAvailable.style.display = "none";
    bookApptBtn.classList.add("none");
    bookApptBtn.classList.add("disabled");
  }
  if (["where", "bar", "treatment"].includes(level)) {
    // dateSelect.disabled = true;
    datePickerStart.disabled = true;
    datePickerEnd.disabled = true;
  }
  if (["where"].includes(level)) {
    treatment.value = "0";
    // treatment.disabled = true;
  }
  if (level === "where") {
    barHolder.classList.add("selected");
    treatmentHolder.classList.add("selected");
    bar.value = "0";
    bar.disabled = true;
    treatment.value = "0";
    // treatment.disabled = true;
  }
}

where.addEventListener("change", (e) => getLocationsBySite(e.target.value));

function updateWhere(whereValue) {
  resetBooking("where");
  for (let i = 0; i < barCollection493689.length; i++) {
    barCollection493689[i].style.display = "none";
  }
  for (let i = 0; i < barCollection5726529.length; i++) {
    barCollection5726529[i].style.display = "none";
  }

  if (whereValue === "493689") {
    bar.disabled = false;
    bar.value = "0";
    treatment.value = "0";
    for (let i = 0; i < barCollection493689.length; i++) {
      barCollection493689[i].style.display = "block";
    }
    return;
  }
  if (whereValue === "5726529") {
    bar.disabled = false;
    for (let i = 0; i < barCollection5726529.length; i++) {
      barCollection5726529[i].style.display = "block";
    }
    bar.value = "5726529-1";
    treatment.disabled = false;
    for (let i = 0; i < treatCollection493689.length; i++) {
      treatCollection493689[i].style.display = "none";
    }
    for (let i = 0; i < treatCollection5726529.length; i++) {
      treatCollection5726529[i].style.display = "block";
    }
    return;
  }
}

bar.addEventListener("change", (e) => updateBar(e.target.value));
function updateBar(barValue) {
  // console.log(barValue);
  resetBooking("bar");
  treatment.disabled = false;
  //   getTreatmentBySite(barValue)
  // console.log(treatment.value);
  if (barValue !== "0" && treatment.value !== "0") {
    // dateSelect.disabled = false;
    bookBtn.disabled = false;
    datePickerStart.disabled = false;
    datePickerEnd.disabled = false;
  }

  return;

  for (let i = 0; i < treatCollection493689.length; i++) {
    treatCollection493689[i].style.display = "none";
  }
  for (let i = 0; i < treatCollection5726529.length; i++) {
    treatCollection5726529[i].style.display = "none";
  }

  if (barValue === "0") {
    return;
  }

  if (where.value === "493689") {
    treatment.disabled = false;
    for (let i = 0; i < treatCollection493689.length; i++) {
      treatCollection493689[i].style.display = "block";
    }
    return;
  }
  if (where.value === "5726529") {
    treatment.disabled = false;
    for (let i = 0; i < treatCollection5726529.length; i++) {
      treatCollection5726529[i].style.display = "block";
    }
    return;
  }
}

treatment.addEventListener("change", (e) => updateTreatment(e.target.value));
function updateTreatment(treatmentValue) {
  resetBooking("treatment");
  if (treatmentValue !== "0" && bar.value !== "0") {
    // dateSelect.disabled = false;
    bookBtn.disabled = false;
    bar.disabled = false;
    datePickerStart.disabled = false;
    datePickerEnd.disabled = false;
  }
}
addEventListener("load", (event) => {
  datePickerStart.setAttribute(
    "data-id",
    moment.tz("Canada/Eastern").startOf("day").toISOString()
  );

  ///
  const easternTimezone = moment.tz("Canada/Eastern");
  const oneWeekLater = easternTimezone.clone().add(1, "week");
  datePickerEnd.setAttribute("data-id", oneWeekLater.toISOString());
  ///

  const today = new Date();
  const nextWeek = new Date(today).setDate(today.getDate() + 7);
  var picker = new Lightpick({
    field: document.getElementById("datePickerStart"),
    secondField: document.getElementById("datePickerEnd"),
    singleDate: false,
    lang: "en",
    format: "DD MMM YYYY",
    startDate: today,
    endDate: new Date(nextWeek),
    minDate: today,
    onSelect: function (start, end) {
      // var str = "";
      var dt = "";
      var dtEnd = "";
      // str += start ? start.format("Do MMMM YYYY") + " to " : "";
      // str += end ? end.format("Do MMMM YYYY") : "...";
      // console.log({ str });

      dt += start ? start.format("DD MMM YYYY") : "...";
      dtEnd += end ? end.format("DD MMM YYYY") : "...";

      // const dt = new Date(start._d);
      // const dtEnd = new Date(end._d);
      bookBtn.disabled = false;
      // datePickerStart.setAttribute("data-id", dt.toLocaleDateString());
      // datePickerEnd.setAttribute("data-id", dtEnd.toLocaleDateString());
      datePickerStart.setAttribute("data-id", dt);
      datePickerEnd.setAttribute("data-id", dtEnd);
    },
  });
});

// CLICK OF FIND AVAILABLE APPOINTMENTS
function quickbarBookAppointment() { 
  overlayElement.style.display = "none";
  contentElement.classList.remove("highlight");
  const visitType = treatment.value.split("-")[1];
  const siteId = where.value;
  const locationId = bar.value.split("-")[1];
  const startDate = datePickerStart.getAttribute("data-id").split("T")[0];
  const endDate = datePickerEnd.getAttribute("data-id").split("T")[0];

  const urlParams = new URLSearchParams({
    startDate,
    endDate,
    siteId,
    locationId,
  });
  bookBtn.classList.add("button--loading");
  let accessTokenBooking = localStorage.getItem("accessToken");
  fetch(`${urlBase}/appointment/appointments/${visitType}?${urlParams}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${accessTokenBooking}`,
    },
  })
    .then((res) => res.json())
    .then((appointments) => {     
      if (
        typeof appointments === "string" ||
        Object.keys(appointments).length === 0
      ) {
        bookingContents.style.display = "none";
        bookHolder.style.display = "none";
        bookingNotAvailable.style.display = "flex";
        bookBtn.classList.remove("button--loading");
        bookApptBtn.classList.add("none");
        return;
      }
      bookingNotAvailable.style.display = "none";
      bookingContents.style.display = "flex";
      bookHolder.style.display = "flex";
      bookingContents.innerHTML = "";
      bookingContents.style.opacity = 1;
      bookingContents.style.alignItems = "left";

      apptDates = {};
      Object.keys(appointments).forEach((appointmentDate) => {
        const dateDiv = document.createElement("div");
        dateDiv.style.marginBottom = "29px";
        // dateDiv.style.width = "814px";
        dateDiv.className = "podHolder";
        const dateTitle = document.createElement("div");
        dateTitle.innerHTML = formatAppointmentDateBooking(
          new Date(appointmentDate)
        );
        dateTitle.style.textAlign = "left";
        dateTitle.className = "dateTime";
        dateTitle.style.color = "#343a40";
        // dateTitle.style.marginBottom = "27px";

        dateDiv.appendChild(dateTitle);

        const dateContainer = document.createElement("div");
        dateContainer.className = "comm-table-col slider-wrapper";
        dateContainer.style.gap = "10px";
        dateContainer.style.position = "relative";

        Object.keys(appointments[appointmentDate]).forEach((staffId) => {
          const podTitle = document.createElement("div");
          podTitle.className = "podTitle";
          podTitle.innerHTML =
            appointments[appointmentDate][staffId].displayName;
          dateContainer.appendChild(podTitle);

          const podContainer = document.createElement("div");
          podContainer.className = "comm-table-col slider";

          const podAppts = document.createElement("div");
          podAppts.className = "slider_top";
          podAppts.id = "slider_top";

          appointments[appointmentDate][staffId].times.map((time) => {
            const apptDiv = document.createElement("div");
            apptDiv.className = "book-date comm-table-col item";
            apptDiv.style.backgroundColor = "#fff";
            apptDiv.style.border = "1px solid #000";
            // apptDiv.style.padding = "26px 94px";
            // apptDiv.style.textTransform = "uppercase";
            apptDiv.style.alignItems = "center";
            apptDiv.style.cursor = "pointer";
            apptDiv.style.minWidth = "271px";
            const dataId = `${siteId}-${locationId}-${staffId}-${time.startDateTime}`;
            apptDiv.setAttribute("data-id", dataId);
            apptDiv.onclick = () =>
              enableBooking(
                dataId,
                siteId,
                locationId,
                staffId,
                time.startDateTime,
                visitType,
                podTitle.innerHTML,
                appointments[appointmentDate][staffId].appointmentName
              );

            const timeDiv = document.createElement("div");
            timeDiv.innerHTML = time.timeSlot;
            timeDiv.style.color = "var(--unnamed-color-212529)";
            timeDiv.style.fontSize = "16px";

            const name = document.createElement("div");
            name.innerHTML =
              appointments[appointmentDate][staffId].appointmentName;
            name.className = "SF";
            name.style.textTransform = "none";
            name.style.color = "var(--unnamed-color-495057)";
            name.style.fontSize = "14px";

            apptDiv.appendChild(timeDiv);
            apptDiv.appendChild(name);

            podAppts.appendChild(apptDiv);
          });
          podContainer.appendChild(podAppts);
          dateContainer.appendChild(podContainer);
          // var sliderTop = document.getElementById("slider_top");
        });
        dateDiv.appendChild(dateContainer);
        bookingContents.appendChild(dateDiv);

        document.querySelectorAll(".book-date").forEach(function (el) {
          el.addEventListener("click", function () {
            document.querySelector("#book-appt-btn").scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
              offsetTop: 50,
            });
          });
        });
        // var sliderTop = document.getElementById("slider_top");
        checkSliders();
      });

      const bookApptBtn = document.getElementById("book-appt-btn");
      bookApptBtn.classList.remove("none");

      bookApptBtn.className = "confirm-button";
      bookApptBtn.style.height = "52px";
      bookApptBtn.style.justifyContent = "center";
      bookApptBtn.style.backgroundColor = "#1ab25d ";
      bookApptBtn.style.color = "#000";

      bookBtn.classList.remove("button--loading");

      var menuItem = document.getElementsByClassName("dateTime");
      var menuLink = menuItem[0];
      // console.log(menuLink);
      menuLink.className += " first";
    })
    .catch((err) => {
      bookBtn.classList.remove("button--loading");
    });
}

function bookAppointment(siteId, locationId, staffId, startDateTime) { 

  bookApptBtn.classList.add("button--loading");
  setTimeout(() => {
    bookApptBtn.classList.remove("button--loading");
  }, 2000);
}

function bookAppointmentPost(data) { 
  let accessTokenBooking = localStorage.getItem("accessToken");  
  const bookApptBtn = document.getElementById("book-appt-btn");
  bookApptBtn.classList.add("button--loading");
  setTimeout(() => {
    bookApptBtn.classList.remove("button--loading");
  }, 2000);
 
    const region = data.siteId
    const accountPath = region === '5729211' ? 'user-us/appointments/book' : 'user/appointments/book';
    fetch(`${urlBase}/${accountPath}`, {
  // fetch(`${urlBase}/user/appointments/book`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${accessTokenBooking}`,
    },
    body: JSON.stringify({
      siteId: data.siteId,
      locationId: data.locationId,
      sessionTypeId: data.visitType,
      staffId: data.staffId,
      startDateTime: data.startDateTime,
      notes: data.note,
    }),
  })
    .then((response) => {
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad response from server");
      }
      return response.json();
    })
    .then((res) => {
      // console.log("🚀 ~ file: booking.js:211 ~ .then ~ res", res);

      // define an object with all the query parameters
      let params = {
        bookingSuccess: "true",
        siteId: data.siteId,
        locationId: data.locationId,
        sessionTypeId: data.visitType,
        // staffId: staffId,
        startDateTime: data.startDateTime,
      };

      // get the current URL
      let url = new URL(window.location.href);

      // add each parameter to the URL
      Object.keys(params).forEach((key) =>
        url.searchParams.append(key, params[key])
      );

      // replace the current URL with the updated one
      window.history.replaceState({}, "", url);

      // console.log("🚀 ~ file: booking.js:211 ~ .then ~ res", params);

      setConfirmationModal(params);
    })
    .catch(() => {});
}

function hideModalClearParams() { 
  // get the current URL
  let url = new URL(window.location.href);
  // clear all query parameters
  url.search = "";
  // replace the current URL with the updated one
  window.history.replaceState({}, "", url);
  document.getElementById("booking-modal").style.display = "none";
  document.getElementById("cc-booking-modal").style.display = "none";
  bookingContents.style.display = "none";
  bookHolder.style.display = "none";
  bookingContents.innerHTML = "";
  bookApptBtn.classList.add("none");
  bookApptBtn.classList.add("disabled");
}

function setConfirmationModal(params) { 
  // window.location.href =
  //   "https://formula-fig-staging.myshopify.com/pages/account?tab=appointments";
  document.getElementById("booking-modal").style.display = "flex";
  document.getElementById("cc-booking-modal").style.display = "none";
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function enableBooking(
  dataId,
  siteId,
  locationId,
  staffId,
  startDateTime,
  visitType,
  title,
  name
) { 
  const dates = document.getElementsByClassName("book-date");
  for (let i = 0; i < dates.length; i++) {
    dates[i].classList.remove("book");
    if (dates[i].getAttribute("data-id") === dataId) {
      dates[i].classList.add("book");
    }
  }
  const bookApptBtn = document.getElementById("book-appt-btn");
  bookApptBtn.classList.remove("disabled");
  // CLICKING OF EACH TREATMENT BLOCK
  bookApptBtn.onclick = () =>
    // SHOW CC MODAL BEFORE MAKING BOOKING
    (document.getElementById("cc-booking-modal").style.display = "block");
  document.getElementById("invalid-tab").style.display = "none";
  document.getElementById("cc-tab").style.display = "none";
  document.getElementById("cc-end").style.display = "block";
  document.getElementById("cc-start").style.display = "block";
  let accessTokenBooking = localStorage.getItem("accessToken");

  if (accessTokenBooking) {
    getUserData(accessTokenBooking);
    document.getElementById("auth-tab").style.display = "none";
  } else {
   
    document.getElementById("auth-tab").style.display = "block";
    document.getElementById("cc-load-btn").style.display = "none";
  }

  let bookTitle = document.getElementById("cc-where");
  document.forms["credit-myForm"]["cc-notes"].value = "";
  if (bookTitle && title) {
    bookTitle.innerHTML = title;
    document.getElementById("cc-date").innerHTML = formatCreditDateBooking(
      new Date(startDateTime)
    );
    document.getElementById("cc-what").innerHTML = name;
  } 

  localStorage.setItem(
    "tempBook",
    JSON.stringify({
      siteId,
      locationId,
      staffId,
      startDateTime,
      visitType,
      title,
      name,
      // bookingNotes,
    })
  );
  const ccBookApptBtn = document.getElementById("cc-book-appt-btn");
  ccBookApptBtn.classList.add("disabled");
  // document.getElementById("cc-load-btn").style.display = "block";
  //   getUserData();
}
const SITE_COUNTRY = {
  "493689": "CA", // Vancouver
  "5726529": "CA", // Toronto
  "5729211": "US", // Los Angeles
};

function enforceBookingRegionOrThrow() {
  const tempBook = JSON.parse(localStorage.getItem("tempBook") || "{}");
  const siteCountry = getSiteCountryFromId(tempBook?.siteId);
  const region = (localStorage.getItem("userRegion") || "").toUpperCase();

  if (!bookingAllowed(region, siteCountry)) {
    // throw a typed error your UI can catch
    const niceRegion = region === "US" ? "United States" : "Non-US";
    const niceSite   = siteCountry === "US" ? "United States" : "Canada";
    const err = new Error(`Blocked: ${niceRegion} users can’t book in ${niceSite}.`);
    err.code = "CROSS_COUNTRY_BLOCK";
    err.meta = { region, siteCountry, siteId: tempBook?.siteId };
    throw err;
  }
}

function enforceBookingRegion() {
  const tempBook = JSON.parse(localStorage.getItem("tempBook") || "{}");
  const siteCountry = getSiteCountryFromId(tempBook?.siteId);
  const region = (localStorage.getItem("userRegion") || "").toUpperCase();

  return bookingAllowed(region, siteCountry);
}


function bookingAllowed(region, siteCountry) {
  if (!region || !siteCountry) return true; // no region/site → don't block
  if (region === "US") return siteCountry === "US";
  return siteCountry === "CA"; // non-US → Canada only
}

function getSiteCountryFromId(siteId) {
  if (!siteId) return null;
  return SITE_COUNTRY[String(siteId)] || null;
}

async function getUserData(token) {  
  let accessTokenBooking = localStorage.getItem("accessToken");
  try {
    const region = (localStorage.getItem('userRegion') || '').toUpperCase();
    const accountPath = region === 'US' ? 'user-us/account' : 'user/account';  
    const res = await fetch(`${urlBase}/${accountPath}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${accessTokenBooking}`,
      },
    });
    const res_1 = await res.json();
  let mboUser = {}; // was [], use object

  if (
    res_1 &&
    res_1.California &&
    res_1.California.Membership &&
    Array.isArray(res_1.California.Membership) &&
    res_1.California.Membership.length > 0
  ) {
    mboUser = res_1.California;
  } else if (
    res_1 &&
    res_1.Vancouver &&
    res_1.Vancouver.Membership &&
    Array.isArray(res_1.Vancouver.Membership) &&
    res_1.Vancouver.Membership.length > 0
  ) {
    mboUser = res_1.Vancouver;
  } else if (
    res_1 &&
    res_1.Toronto &&
    res_1.Toronto.Membership &&
    Array.isArray(res_1.Toronto.Membership) &&
    res_1.Toronto.Membership.length > 0
  ) {
    mboUser = res_1.Toronto;
  } else if (res_1 && res_1.California) {
    mboUser = res_1.California;
  } else if (res_1 && res_1.Vancouver) {
    mboUser = res_1.Vancouver;
  } else if (res_1 && res_1.Toronto) {
    mboUser = res_1.Toronto;
  }    

    const ccContainer = document.createElement("div");
    ccContainer.className = "comm-table-row";
    document.getElementById("payment-info").innerHTML = "";

  // if (!enforceBookingRegion()) {
  // document.getElementById("invalid-tab").style.display = "block";
  //  document.getElementById("cc-load-btn").style.display = "none";
  
  //  document.getElementById('auth-tab').style.display = 'none';
  //   document.getElementById("cc-start").style.display = "none";
  //    document.getElementById("cc-end").style.display = "none";
  //     return updateAccountData(mboUser);

 if (mboUser.ClientCreditCard?.LastFour !== "") {
      document.getElementById("cc-tab").style.display = "none";
      document.getElementById("cc-end").style.display = "block";
      document.getElementById("cc-start").style.display = "block";

      const elementToHide = document.getElementById("add-new");
      if (elementToHide) {
        document.getElementById("add-new").style.display = "none";
      }

      const ccCardInfo = document.createElement("div");
      ccCardInfo.className = "comm-table-col";

      const ccCardInfoTitle = document.createElement("div");
      ccCardInfoTitle.innerHTML = `${mboUser.ClientCreditCard.CardType}  -  ${mboUser.ClientCreditCard.CardHolder}`;
      ccCardInfoTitle.className = "";

      const ccCardInfoBody = document.createElement("div");
      ccCardInfoBody.innerHTML = `XXXX-${mboUser.ClientCreditCard.LastFour}`;
      ccCardInfo.appendChild(ccCardInfoTitle);
      ccCardInfo.appendChild(ccCardInfoBody);
      ccContainer.appendChild(ccCardInfo);

      const ccActions = document.createElement("div");
      ccActions.className = "comm-table-row";

      const ccEdit = document.createElement("div");
      ccEdit.className = "comm-table-col";
      ccEdit.innerHTML = "EDIT";
      ccEdit.style.cursor = "pointer";
      ccEdit.onclick = () => getCCData();

      const ccDelete = document.createElement("div");
      ccDelete.className = "comm-table-col";
      ccDelete.innerHTML = "DELETE";
      ccDelete.style.cursor = "pointer";
      ccDelete.onclick = () => loadDeleteMe(() => deleteCCBooking());

      const ccSpacer = document.createElement("div");
      ccSpacer.innerHTML = "&nbsp;&nbsp;|&nbsp;&nbsp;";
      ccActions.appendChild(ccDelete);
      ccContainer.appendChild(ccActions);
      const ccBookApptBtn = document.getElementById("cc-book-appt-btn");
      ccBookApptBtn.classList.remove("disabled");

      const elementToRemove = document.getElementById("cc-tab");
      if (elementToRemove) {
       
      }

      const field2Input = document.getElementById("cname");
      field2Input.required = !field2Input.required;

      const field2Input1 = document.getElementById("ccnum");
      field2Input1.required = !field2Input1.required;

      const field2Input2 = document.getElementById("adr");
      field2Input2.required = !field2Input2.required;

      const field2Input3 = document.getElementById("city");
      field2Input3.required = !field2Input3.required;

      const field2Input4 = document.getElementById("state");
      field2Input4.required = !field2Input4.required;

      const field2Input5 = document.getElementById("zip");
      field2Input5.required = !field2Input5.required;
    } else {
      const ccBookApptBtn = document.getElementById("cc-book-appt-btn");
      ccBookApptBtn.classList.add("disabled");
      const ccAddNew = document.createElement("div");
      ccAddNew.className = "comm-table-col medium";
      ccAddNew.id = "add-new";
      ccAddNew.innerHTML = "+ ADD A NEW CARD";
      ccAddNew.style.cursor = "pointer";
      ccAddNew.style.textDecoration = "underline";
      ccAddNew.style.fontSize = "14px";
      ccAddNew.style.color = "red";
      ccAddNew.onclick = () => addNewBookingCC();
      ccContainer.style.justifyContent = "left";
      ccContainer.appendChild(ccAddNew);
    }
    document.getElementById("payment-info").appendChild(ccContainer);
    document.getElementById("cc-load-btn").style.display = "none";
    return updateAccountData(mboUser);
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null; // Return null in case of an error
  }
}

function deleteCCBooking() {
  let accessTokenBooking = localStorage.getItem("accessToken");

  document.getElementById("loadMe").style.visibility = "visible";

  const region = (localStorage.getItem('userRegion') || '').toUpperCase();
  const accountPath = region === 'US' ? 'user-us/creditCard' : 'user/creditCard';

  fetch(`${urlBase}/${accountPath}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${accessTokenBooking}`,
    },
  })
    .then((res) => res.json())
    .then(async (classes) => {
      await getUserData(accessTokenBooking);
      document.getElementById("loadMe").style.visibility = "hidden";
    });
}

function addNewBookingCC() {
  document.getElementById("cc-tab").style.display = "block";
  document.getElementById("cc-end").style.display = "none";
  document.getElementById("cc-start").style.display = "none";
  document.getElementById("add-new").style.display = "none";

  document.getElementById("adr").value = "";
  document.getElementById("cname").value = "";
  document.getElementById("city").value = "";
  document.getElementById("expmonth").value = "";
  document.getElementById("expyear").value = "";
  document.getElementById("ccnum").value = "";
  document.getElementById("zip").value = "";
  document.getElementById("state").value = "";
  resetMoYr();
}

if (urlParams.get("site")) {
  where.value = urlParams.get("site");
  updateWhere(urlParams.get("site"));
}
if (urlParams.get("site") && urlParams.get("bar")) {
  bar.value = `${urlParams.get("site")}-${urlParams.get("bar")}`;
  updateBar(`${urlParams.get("site")}-${urlParams.get("bar")}`);
}
if (urlParams.get("site") && urlParams.get("bar") && urlParams.get("what")) {
  treatment.value = `${urlParams.get("site")}-${urlParams.get("what")}`;  
  updateTreatment(`${urlParams.get("site")}-${urlParams.get("what")}`);
}

function getLocationsBySite(siteId) {  
  let accessTokenBooking = localStorage.getItem("accessToken"); 
  // if (siteId === "5729211") {    
  //   var newUrl =
  //     "https://us.formulafig.com/pages/appointments";    
  //   var paramUrl = newUrl + "?site=" + siteId;    
  //   window.location.href = paramUrl;
  // }

  overlayElement.style.display = "none";
  contentElement.classList.remove("highlight");
  resetBooking("where");
  getTreatmentBySite(siteId);
  wehoBars = JSON.parse(localStorage.getItem("wehoBars"));
  vancouverBars = JSON.parse(localStorage.getItem("vancouverBars"));
  torontoBars = JSON.parse(localStorage.getItem("torontoBars"));
  if (!vancouverBars || !torontoBars || !wehoBars) {
    document.getElementById("location-loading").style.display = "block";
    document.getElementById("locationSelect").style.display = "none";
    fetch(`${urlBase}/mbo/locations/${siteId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${accessTokenBooking}`,
      },
    })
      .then((response) => {
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then((res) => {
        if (res) {
          for (const key in res) {
            if (res[key] === "Online Store") {
              delete res[key];
            }
          }
          createDropdown(res, siteId);
          switch (siteId) {
             case "5729211":
              wehoBars = res;
              localStorage.setItem("wehoBars", JSON.stringify(res));
              break;
            case "493689":
              vancouverBars = res;
              localStorage.setItem("vancouverBars", JSON.stringify(res));
              break;
            case "5726529":
              torontoBars = res;
              localStorage.setItem("torontoBars", JSON.stringify(res));
              break;
            default:
            // code block
          }
        }
      })
      .catch(() => {});
  } else {
    switch (siteId) {
       case "5729211":
        createDropdown(wehoBars, siteId);
        break;
      case "493689":
        createDropdown(vancouverBars, siteId);
        break;
      case "5726529":
        createDropdown(torontoBars, siteId);
        break;
      default:
      // code block
    }
  }
}

function getTreatmentBySite(siteId) {  
  let accessTokenBooking = localStorage.getItem("accessToken");
  wehoTreatments25= JSON.parse(localStorage.getItem("wehoTreatments25"));
  vancouverTreatments25 = JSON.parse(localStorage.getItem("vancouverTreatments25"));
  torontoTreatments25 = JSON.parse(localStorage.getItem("torontoTreatments25"));
  if (!vancouverTreatments25 || !torontoTreatments25 || !wehoTreatments25) {
    fetch(`${urlBase}/mbo/sessiontypesperprogram/${siteId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${accessTokenBooking}`,
      },
    })
      .then((response) => {
        if (response.status >= 400 && response.status < 600) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then((res) => {
        if (res) {         
          // createDropdown(res);
          switch (siteId) {
             case "5729211":
              wehoTreatments25 = res;
              localStorage.setItem("wehoTreatments25", JSON.stringify(res));
              break;
            case "493689":
              vancouverTreatments25 = res;
              localStorage.setItem("vancouverTreatments25", JSON.stringify(res));
              break;
            case "5726529":
              torontoTreatments25 = res;
              localStorage.setItem("torontoTreatments25", JSON.stringify(res));
              break;
            default:
            // code block
          }
          createDropdownTreatment(res, siteId);
        }
      })
      .catch(() => {});
  } else {
    switch (siteId) {
       case "5729211":
        createDropdownTreatment(wehoTreatments25, siteId);
        break;
      case "493689":
        createDropdownTreatment(vancouverTreatments25, siteId);
        break;
      case "5726529":
        createDropdownTreatment(torontoTreatments25, siteId);
        break;
      default:
      // code block
    }
  }
}

function createDropdown(res, siteId) {
  const locationDropdown = document.getElementById("locationSelect");
  locationDropdown.innerHTML = "<option value='0'>Select Fig Bar</option>";
  for (const [key, value] of Object.entries(res)) {
    // if (value != "Summerhill") {
    const option = document.createElement("option");
    option.value = siteId + "-" + key;
    option.text = value;
    locationDropdown.add(option);
    // }
  }
  locationDropdown.disabled = false;
  document.getElementById("location-loading").style.display = "none";
  document.getElementById("locationSelect").style.display = "block";
}

function setSelectValue(value) {
  const selectElement = document.getElementById("options_treatment_id");
  const treatmentHolder = document.getElementById("treatment-holder");

  if (value === "0") {
    selectElement.classList.add("selected");
    treatmentHolder.classList.add("selected");
  } else if (value) {
    treatmentHolder.classList.remove("selected");
    selectElement.classList.remove("selected");
  } else {
    treatmentHolder.classList.remove("selected");
    selectElement.classList.remove("selected");
  }

  selectElement.value = value;
  // scroll to top of page
  window.scrollTo({ top: 0, behavior: "smooth" });

  // add highlight class to content element
  contentElement.classList.add("highlight");

  // show overlay
  overlayElement.style.display = "block";

  // add click event listener to overlay to hide it and remove highlight class
  overlayElement.addEventListener("click", function () {
    overlayElement.style.display = "none";
    contentElement.classList.remove("highlight");
  });
}

function createDropdownTreatment(res, siteId) {
  treatment.innerHTML = "<option value='0'>Select treatment</option>";

  let siteName = "";
  switch (siteId) {
     case "5729211":
      siteName = "Los Angeles";
      break;
    case "493689":
      siteName = "Vancouver";
      break;
    case "5726529":
      siteName = "Toronto";
      break;
    default:
      break;
  }

  const highLevelOrder = [
    "Brand Activations",  
    "Injectables",
      "Needling Treatments", // Inserted second
    "High Tech Facials",
    "Light Therapy Boost"
  ];

  const needlingNames = [
    "The Longevity Treatment",
    "Collagen + Texture Supers Facial"
  ];

  const highTechFacialsOrder = [
    "The Bespoke 60-Minute Facial",
    "All-In Supers Facial",
    "Sculpt + Clear Core Facial",
    "Lift + Tone Core Facial",
    "Hydrate + Glow Core Facial",
    "LED + Lymphatic Core Facial",
    "Pregnancy Core Facial"   
  ];

  let needlingGroup = null;

  // Extract Needling Treatments from High Tech Facials
  for (let i = 0; i < res.length; i++) {
    const value = res[i];
    if (value.name === "High Tech Facials") {
      const needlingTreatments = needlingNames
        .map(name => value.sessiontypes.find(st => st.Name === name))
        .filter(Boolean);

      value.sessiontypes = value.sessiontypes.filter(
        st => !needlingNames.includes(st.Name)
      );

      value.sessiontypes = highTechFacialsOrder
        .map(name => value.sessiontypes.find(st => st.Name === name))
        .filter(Boolean);

      needlingGroup = {
        name: "Needling Treatments",
        sessiontypes: needlingTreatments
      };

      break;
    }
  }

  // Reorder top-level categories and insert Needling Treatments
  res = highLevelOrder.map(name => {
    if (name === "Needling Treatments") return needlingGroup;
    return res.find(appt => appt.name === name);
  }).filter(Boolean);

  for (const value of res) {
    const optgroup = document.createElement("optgroup");
    optgroup.label = value.name;

    if (
      value.name !== "Late Cancel" &&
      value.name !== "Training" &&
      value.name !== "Brand Activations"
    ) {
      treatment.add(optgroup);

      for (const data of value.sessiontypes) {
        if (
          data.Name !== "Guest Pass | Hydrate + Glow" &&
          data.Name !== "Training Facial" &&
          data.Name !== "Guest Passes | Hydrate + Glow" &&
          data.Name !== "Guest Pass | All-In" &&
          data.Name !== "Oxygen Serum Blast" &&
          data.Name !== "IV + LED" &&
          data.Name !== "Radiance + Renewal Laser Facial" &&
          data.Name !== "Dissolving Fee" &&
          data.Name !== "Stingers Follow Up" &&
          data.Name !== "Fig Shot" &&
          data.Name !== "Injectables Follow-Up" &&
          data.Name !== "Injectables Treatment" &&
          data.Name !== "Injectables Consultation" &&
          data.Name !== "Fig x Loa Facial Series 02" &&
          data.Name !== "Fig x VENN Facial Series 03" &&
          data.Name !== "Fig x 111Skin Facial Series 05" &&
          data.Name !== "FORMULA FIG X HOLIFROG Lift + Tone" &&
          data.Name !== "FORMULA FIG X OKOKO Cosmétiques Lift + Tone" &&
          data.Name !== "FORMULA FIG x VENN Facial Series" &&
          data.Name !== "FORMULA FIG X THE OUTSET Facial Series" &&
          data.Name !== "FORMULA FIG X SALTYFACE" &&
          data.Name !== "LED + Lymphatic Event Facial" &&
          data.Name !== "Collagen + Hydration - Aura Inner Beauty Facial" &&
          data.Name !== "FF x Venn Facial Series" &&
          data.Name !== "FF x MIFA" &&
          data.Name !== "CHEEKBONE BEAUTY" &&
          data.Name !== "FF x BBDO"
        ) {
          if (hardCodedList) {
            const match = hardCodedList.find(
              (item) =>
                item.name === data.Name && item.sessionTypeId === data.Id
            );

            if (match) {
              data.Price = match.price;
              data.link = match.link;
              data.note = match.note;
            }
          }

          const option = document.createElement("option");
          option.value = siteId + "-" + data.Id;
          option.text = data.Name;
          treatment.add(option);

          const div = document.createElement("div");
          div.className = "single-treat";

          const leftDiv = document.createElement("div");
          leftDiv.className = "left";

          const category = document.createElement("h4");
          category.className = "FG";
          category.textContent = optgroup.label;

          const name = document.createElement("h5");
          name.className = "FF";
          name.textContent = data.Name;

          leftDiv.appendChild(category);
          leftDiv.appendChild(name);

          const rightDiv = document.createElement("div");
          rightDiv.className = "right";

          const priceDiv = document.createElement("div");
          priceDiv.className = "price FG";
          if (data.note) {
            priceDiv.innerHTML =
              data.Price + "<br/>" + "<span>" + data.note + "</span>";
          } else {
            priceDiv.textContent = data.Price;
          }

          const btnHolderDiv = document.createElement("div");
          btnHolderDiv.className = "btn-holder";

          const singleBookBtn = document.createElement("button");
          singleBookBtn.textContent = "BOOK NOW";
          singleBookBtn.className = "book";
          singleBookBtn.id = option.value;
          singleBookBtn.addEventListener("click", function () {
            setSelectValue(singleBookBtn.id);
          });

          const detailsBtn = document.createElement("button");
          detailsBtn.textContent = "DETAILS";
          detailsBtn.className = "";
          detailsBtn.addEventListener("click", function () {
            if (data.link) {
              window.open(data.link, "_blank");
            } else {
              window.open("/pages/treatments", "_blank");
            }
          });

          btnHolderDiv.appendChild(singleBookBtn);
          btnHolderDiv.appendChild(detailsBtn);
          rightDiv.appendChild(priceDiv);
          rightDiv.appendChild(btnHolderDiv);
          div.appendChild(leftDiv);
          div.appendChild(rightDiv);

          // treatmentList.appendChild(div); // optional
        }
      }
    }
  }
}


function addSCroll() {
  // Get references to the left and right scroll buttons
  var scrollLeftButton = document.getElementsByClassName("arrow-left");
  var scrollRightButton = document.getElementsByClassName("arrow-right");

  for (var i = 0; i < scrollLeftButton.length; i++) {
    // Adjust the scroll position by 100 pixels to the left
    scrollLeftButton[i].scrollLeft -= 100;
  }

  // Add click event listeners to the scroll buttons
  scrollLeftButton.addEventListener("click", function () {
    // Loop through all elements with the "scrollable" class
    var scrollableElements = document.getElementsByClassName("slider_top");
    for (var i = 0; i < scrollableElements.length; i++) {
      // Adjust the scroll position by 100 pixels to the left
      scrollableElements[i].scrollLeft -= 100;
    }
  });

  scrollRightButton.addEventListener("click", function () {
    // Loop through all elements with the "scrollable" class
    var scrollableElements = document.getElementsByClassName("slider_top");
    for (var i = 0; i < scrollableElements.length; i++) {
      // Adjust the scroll position by 100 pixels to the right
      scrollableElements[i].scrollLeft += 100;
    }
  });
}

function checkSliders() {
  // Get all elements with class "slider_top"
  var sliderTops = document.querySelectorAll(".slider");

  // Iterate over each element with class "slider_top"
  for (var i = 0; i < sliderTops.length; i++) {
    // Get the width of the current element
    var sliderTopWidth = sliderTops[i].offsetWidth;
    var currentIndex = i;
    sliderTops[i].classList.add(`active${currentIndex}`);

    // Check if the current element is wider than 500 pixels
    if (sliderTopWidth > 813) {
      // Check if the buttons have already been added to this slider
      if (!sliderTops[i].classList.contains("slider-with-buttons")) {
        // Create the previous button
        var prevButton = document.createElement("button");
        prevButton.textContent = "";
        prevButton.className = "arrow-left disabled";
        // Add a click event listener to the previous button
        prevButton.addEventListener(
          "click",
          (function (currentIndex) {
            return function () {
              var scrollableElements = document.getElementsByClassName(
                `active${currentIndex}`
              );
              // console.log("scrollableElements :::::", scrollableElements);
              for (var r = 0; r < scrollableElements.length; r++) {
                // Adjust the scroll position by 100 pixels to the left
                scrollableElements[r].scrollLeft -= 271;
              }
            };
          })(currentIndex)
        );

        // Create the next button
        var nextButton = document.createElement("button");
        nextButton.textContent = "";
        nextButton.className = "arrow-right";
        // Add a click event listener to the next button
        nextButton.addEventListener(
          "click",
          (function (currentIndex) {
            return function () {
              var scrollableElements = document.getElementsByClassName(
                `active${currentIndex}`
              );
              // console.log("scrollableElements :::::", scrollableElements);
              for (var r = 0; r < scrollableElements.length; r++) {
                // Adjust the scroll position by 100 pixels to the right
                scrollableElements[r].scrollLeft += 271;
              }
            };
          })(currentIndex)
        );

        // Append the buttons to the current slider_top element
        sliderTops[i].appendChild(prevButton);
        sliderTops[i].appendChild(nextButton);

        // Add a class to the slider to indicate that buttons have been added
        sliderTops[i].classList.add("slider-with-buttons");
      }
      sliderTops[i].addEventListener(
        "scroll",
        (function (currentIndex) {
          return function () {
            var scrollableElements = document.getElementsByClassName(
              `active${currentIndex}`
            );
            var arrowLeft =
              sliderTops[currentIndex].querySelector(".arrow-left");
            var arrowRight =
              sliderTops[currentIndex].querySelector(".arrow-right");
            for (var r = 0; r < scrollableElements.length; r++) {
              if (scrollableElements[r].scrollLeft !== 0) {
                arrowLeft.classList.remove("disabled");
              } else {
                arrowLeft.classList.add("disabled");
              }

              if (
                scrollableElements[r].scrollLeft +
                  scrollableElements[r].clientWidth >=
                scrollableElements[r].scrollWidth
              ) {
                arrowRight.classList.add("disabled");
              } else {
                arrowRight.classList.remove("disabled");
              }
            }
          };
        })(currentIndex)
      );
    }
  }
}

function scrollLeft(value) {
  var sliderTops = document.querySelector(`.active${value}`);
  // console.log(" sliderTops :: ", sliderTops);
  // Iterate over each element with class "slider_top"
  for (var i = 0; i < sliderTops.length; i++) {
    // sliderTops.forEach(function (sliderTop) {
    // var currentScroll = sliderTops.scrollLeft;
    // console.log("xxxx:", currentScroll);
    sliderTops[i].scrollTo({
      left: -271,
      behavior: "smooth",
    });
    // });
  }
}

function scrollRight() {
  var sliderTops = document.querySelectorAll(".slider");
  var closestSlider = null;
  var minDistance = Infinity;
  var distance;

  // Iterate over each element with class "slider"
  sliderTops.forEach(function (sliderTop) {
    // Calculate the distance between the slider and the user's view
    distance = Math.abs(
      sliderTop.getBoundingClientRect().left - window.innerWidth / 2
    );

    // Check if the current slider is closer than the current closest slider
    if (distance < minDistance) {
      closestSlider = sliderTop;
      minDistance = distance;
    }
  });

  // Scroll the closest slider to the right
  var currentScroll = closestSlider.scrollLeft;
  closestSlider.scrollTo({
    left: currentScroll + 271,
    behavior: "smooth",
  });
}

function formatAppointmentDateBooking(date, noYear = false) {
  const dayOfWeekName = new Date(date).toLocaleString("default", {
    weekday: "long",
  });
  const monthName = new Date(date).toLocaleString("default", { month: "long" });
  if (noYear)
    return [dayOfWeekName + ",", monthName, padTo2Digits(date.getDate())].join(
      " "
    );

  return [
    dayOfWeekName + ",",
    padTo2Digits(date.getDate()),
    monthName,
    date.getFullYear(),
  ].join(" ");
}

function formatCreditDateBooking(date) {
  const day = date.getDate();
  const monthName = new Date(date).toLocaleString("default", { month: "long" });
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const period = hours >= 12 ? "pm" : "am";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");

  const timeZone = new Date(date)
    .toLocaleString("default", { timeZoneName: "short" })
    .split(" ")
    .pop(); // Extract the last part of the time zone string

  const formattedDate = `${day} ${monthName} ${year}, ${formattedHours}:${formattedMinutes} ${period} ${timeZone}`;

  return formattedDate;
}

// Get all the buttons with class "treatments__booknow__btn"
const buttons = document.querySelectorAll(".treatments__booknow__btn");

// Add an event listener to each button
buttons.forEach((button) => {
  button.addEventListener("click", function () {
    const buttonId = this.id;
    setSelectValue(buttonId);
  });
});
